import React, { useState } from 'react';
import RecommendationCard from './RecommendationCard';
import '../../styles/Dashboard/Recommendations.css';

const Recommendations = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const recommendations = [
    {
      platform: 'Amazon',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg',
      title: 'SBC product: update listing',
      description: 'ABC has been getting consistently increasing traffic over last week but the conversion had reduced by 50%. Consider updating the product listing or review pricing strategy.',
      tag: 'New',
      percentage: '+0.02%',
      isPositive: true
    },
    {
      platform: 'Shopify',
      logo: 'https://cdn.worldvectorlogo.com/logos/shopify.svg',
      title: 'SBC product: update listing',
      description: 'ABC has been getting consistently increasing traffic over last week but the conversion had reduced by 50%. Consider updating the product listing.',
      percentage: '-2.5%',
      isPositive: false
    },
    // Add more recommendations as needed
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => 
      prev === recommendations.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => 
      prev === 0 ? recommendations.length - 1 : prev - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="recommendations-container">
      <div className="recommendations-header">
        <h3>Top recommendation for you</h3>
        <div className="navigation-arrows">
          <button onClick={prevSlide} className="nav-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button onClick={nextSlide} className="nav-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>
      </div>

      <div className="carousel-container">
        <div 
          className="carousel-track" 
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {recommendations.map((recommendation, index) => (
            <RecommendationCard 
              key={index}
              {...recommendation}
            />
          ))}
        </div>
      </div>

      <div className="carousel-dots">
        {recommendations.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Recommendations;